import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosCreateScheduleControllerModule } from './controllers/ProgramsCombosCreateScheduleController';

export const ProgramsCombosCreateScheduleView = angular
  .module('acme.view.application.programs.combos.create.schedule', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosCreateScheduleControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos.create.schedule',
      url: '/schedule',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateScheduleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/schedule/schedule.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Combo Schedule',
      },
    });

    $stateProvider.state({
      name: 'application.programs.combos.edit.schedule',
      url: '/schedule',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateScheduleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/schedule/schedule.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Combo Schedule',
      },
    });
  }).name;
